export interface SeasonInfo {
  label: string;
  start: number;
  daysLeft: number;
}

/** Pure UTC epoch label used immediately by the menu and later by relay reads. */
export function seasonInfo(now = new Date()): SeasonInfo {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const start = Math.floor(Date.UTC(y, m, 1) / 1000);
  const end = Math.floor(Date.UTC(y, m + 1, 1) / 1000);
  const daysLeft = Math.max(1, Math.ceil((end - now.getTime() / 1000) / 86400));
  return { label: `EPOCH ${y}.${String(m + 1).padStart(2, '0')}`, start, daysLeft };
}
